module.exports = __webpack_public_path__ + "static/media/rw-widgets.eceddf47.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/react-widgets/fonts/rw-widgets.ttf
// module id = 333
// module chunks = 0